"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MULTIUSE_END = exports.MULTIUSE_START = exports.ShortRangeRentThreshold = exports.MaxBedroomCount = exports.DateFlexibility = exports.NoStartDateMonthLimit = void 0;
var NoStartDateMonthLimit = 4;
exports.NoStartDateMonthLimit = NoStartDateMonthLimit;
var DateFlexibility = 14;
exports.DateFlexibility = DateFlexibility;
var MaxBedroomCount = 8;
exports.MaxBedroomCount = MaxBedroomCount;
var ShortRangeRentThreshold = 28;
exports.ShortRangeRentThreshold = ShortRangeRentThreshold;
var MULTIUSE_START = '1500-01-01T00:00:00Z';
exports.MULTIUSE_START = MULTIUSE_START;
var MULTIUSE_END = '2500-01-01T00:00:00Z';
exports.MULTIUSE_END = MULTIUSE_END;